module.exports = __webpack_public_path__ + "static/media/result_lsa_ja.63034bda.png";